import { RouterPath } from '@definitions/routes';
import { TransferClients } from '@pages/transfer-clients';
import { TransferItem } from '@pages/transfer-item';
import { TransferCampaign } from '@pages/transfer-compaign';

const routes: RouterPath[] = [
    {
        path: '/transfer-clients',
        render: () => <TransferClients />,
        auth: true,
        allowedRoles: ["PROMOTOR"],
    },
    {
        path: '/register/transfer-clients',
        render: () => <TransferClients />,
        auth: true,
        allowedRoles: [],
    },
    {
        path: '/transfer-items',
        render: () => <TransferItem />,
        auth: true,
        allowedRoles: ["PROMOTOR"],
    },
    {
        path: '/register/transfer-items',
        render: () => <TransferItem />,
        auth: true,
        allowedRoles: [],
    },
    {
        path: '/transfer-campains',
        render: () => <TransferCampaign />,
        auth: true,
        allowedRoles: [],
    },
];

export default routes;
